import { RESULT_LABEL, reasonText } from '../labels';
import type { Candidate } from '../types';

interface Props {
  candidates: Candidate[];
  onSelect: (candidate: Candidate) => void;
}

/**
 * GELB ist kein Ergebnis, sondern eine Frage. Jeder Eintrag nennt deshalb,
 * was bei Bestätigung herauskäme und warum, sonst müsste die Duty-Kraft
 * raten, und zwei Namensvettern wären nicht auseinanderzuhalten.
 */
export function CandidateList({ candidates, onSelect }: Props) {
  return (
    <ul class="candidates" aria-label="Mögliche Personen">
      {candidates.map((candidate) => {
        const reason = reasonText(candidate.reason);
        return (
          <li key={candidate.personId}>
            <button
              class={`candidate candidate--${candidate.wouldBe}`}
              onClick={() => onSelect(candidate)}
            >
              <span class="candidate__name">
                {candidate.firstName} {candidate.lastName}
              </span>
              <span class="candidate__meta">
                {[candidate.jamaat, candidate.extIdTail ? `…${candidate.extIdTail}` : null]
                  .filter(Boolean)
                  .join(' · ')}
              </span>
              <span class="candidate__verdict" aria-hidden="true">
                {RESULT_LABEL[candidate.wouldBe].icon}
              </span>
              {reason && <span class="candidate__reason">{reason}</span>}
            </button>
          </li>
        );
      })}
    </ul>
  );
}
